import { render, staticRenderFns } from "./MedicalStaffMappingPcc.vue?vue&type=template&id=5b246862"
import script from "./MedicalStaffMappingPcc.vue?vue&type=script&lang=js"
export * from "./MedicalStaffMappingPcc.vue?vue&type=script&lang=js"
import style0 from "./MedicalStaffMappingPcc.vue?vue&type=style&index=0&id=5b246862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports